module.exports = __webpack_public_path__ + "img/pytrace-ui.7f43dca5.png";